import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const MenkyoshoAddressKakunin = props => {
  return <Dropdown.Static kubunKey='menkyosho_address_kakunin_kbn' {...props} />
}
